








import Vue from 'vue';
import JerseyButton from '@/components/elements/JerseyButton.vue';

export default Vue.extend({
  name: 'JerseyButtonRed',
  props: {
    view: String,
    action: Function,
    isFlipped: {
      default: false,
      type: Boolean,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {},
  components: { JerseyButton },
});
